import { screens } from '@liveauctioneers/hammer-ui-theme';

import useIsWiderThan from './useIsWiderThan';

const TABLET_NARROW_WIDTH = parseInt(screens.xsMax.max);

export const useIsMobileLayout = () => {
    return !useIsWiderThan(TABLET_NARROW_WIDTH);
};
